/** @format */

import React from 'react';
import './modal.sass';

/**
 * Modal class
 * Very simple wrapping component to show a modal with some content
 * Currently, only provides one button to close the modal
 *
 * TODO: To be deleted once the ModalV2 is used everywhere in the account
 */
class Modal extends React.Component {
    componentDidMount() {
        document.body.style.height = '100%';
        //  document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.height = 'auto';
        document.body.style.overflow = 'auto';
    }

    render() {
        const showCloseBtn = this.props.closeBtn;
        const showX = this.props.showX;

        let closeBtn;
        if (!showCloseBtn) {
            closeBtn = '';
        } else {
            closeBtn = (
                <button className="btn btn-danger" onClick={this.props.onClose}>
                    Close
                </button>
            );
        }

        let xButton;
        if (!showX) {
            xButton = '';
        } else {
            xButton = (
                <div className="modal-window__close" onClick={this.props.onClose}>
                    <img src="/images/icons/close.png" alt="close icon" />
                </div>
            );
        }

        return (
            <div className="modal-window__container">
                <div className="modal-window" style={{borderRadius: '4px', ...this.props.style}}>
                    <div className="modal-window__content">{this.props.children}</div>
                    <div className="modal-window__buttons">{closeBtn}</div>
                    {xButton}
                </div>
                <div
                    className="modal-window__overlay"
                    onClick={this.props.disableOverlayClick ? undefined : this.props.onClose}
                />
            </div>
        );
    }
}

Modal.defaultProps = {
    onClose: () => {}
};

export default Modal;
